// extracted by mini-css-extract-plugin
export default {"termsAndSekkiContainer":"TermsAndSekkiCard_termsAndSekkiContainer__B3SvM","subtitle":"TermsAndSekkiCard_subtitle__tn27f"};